import { Plane, ArrowUpRight } from "lucide-react";
import { FOOTER_LINKS } from "../mock";

export const Footer = ({ onCtaClick }) => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050814] border-t border-white/10 pt-28 pb-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Big final CTA */}
        <div className="border-y border-white/10 py-20 mb-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 items-end gap-10">
            <div className="lg:col-span-8">
              <span className="overline">Final call</span>
              <h3 className="font-heading mt-4 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.02]">
                Ready to put your fleet
                <br />
                <span className="gold-text">under absolute command?</span>
              </h3>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <button
                data-testid="footer-cta"
                onClick={onCtaClick}
                className="group inline-flex items-center gap-3 bg-[#C19A5D] text-[#050814] hover:bg-[#D4AF74] transition-all duration-300 px-8 py-5 font-semibold uppercase tracking-wider text-sm"
              >
                Let's Talk
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
              </button>
            </div>
          </div>
        </div>

        {/* Footer columns */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <span className="relative flex h-9 w-9 items-center justify-center border border-[#C19A5D]/60 bg-[#0A1128]">
                <Plane className="h-4 w-4 text-[#C19A5D]" strokeWidth={1.5} />
              </span>
              <span className="font-heading text-lg font-semibold tracking-tight">
                Omni<span className="text-[#C19A5D]">Link</span>
              </span>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-xs">
              Aviation management, engineered for operators who refuse to compromise on safety,
              compliance or control.
            </p>
            <div className="mt-6 text-xs text-white/40 uppercase tracking-wider">
              omnilinkweb.org
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([heading, items]) => (
            <div key={heading} className="col-span-1">
              <div className="overline mb-5">{heading}</div>
              <ul className="space-y-3">
                {items.map((it) => (
                  <li key={it}>
                    <a
                      href="#contact"
                      data-testid={`footer-link-${it.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm text-white/60 hover:text-white transition-colors link-underline"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom strip */}
        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/40">
          <div>© {new Date().getFullYear()} OmniLink. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <a href="#contact" className="hover:text-white/80 transition-colors">Privacy</a>
            <a href="#contact" className="hover:text-white/80 transition-colors">Terms</a>
            <a href="#contact" className="hover:text-white/80 transition-colors">Security</a>
            <span className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 bg-[#C19A5D] pulse-dot rounded-full" />
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
